module.exports = __webpack_public_path__ + "img/1477190991.5b822698.jpg";